// extracted by mini-css-extract-plugin
export var lg = "_jv-7";
export var md = "_jv-6";
export var placeholderContainer = "_jv-1";
export var placeholderIcon = "_jv-2";
export var productImage = "_jv-0";
export var sm = "_jv-5";
export var xl = "_jv-8";
export var xs = "_jv-4";
export var xxs = "_jv-3";